import { render } from "./TablePagination.vue?vue&type=template&id=5a185f32"
import script from "./TablePagination.vue?vue&type=script&lang=js"
export * from "./TablePagination.vue?vue&type=script&lang=js"

import "./TablePagination.vue?vue&type=style&index=0&id=5a185f32&lang=scss"
script.render = render

export default script